import React from "react";
import ReactDOM from "react-dom";

import { BrowserRouter } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";

import { QueryClientProvider } from "react-query";
import { Provider } from "react-redux";

import store from "@/library/redux";
import query from "@/library/query";

import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <Helmet>
        <title>Verti-pit</title>
      </Helmet>
      <Provider store={store}>
        <QueryClientProvider client={query}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);
